import { render, staticRenderFns } from "./t-dialog-import.vue?vue&type=template&id=535e6d14&"
import script from "./t-dialog-import.vue?vue&type=script&lang=js&"
export * from "./t-dialog-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports